// 专门处理权限路由的模块
import { publicRoutes, resetRouter } from '@/router'
import { getItem, setItem } from '@/utils/storage'
import { deepCopy } from '@/utils/common.js'
import Layout from '@/layout/index'
import ParentView from '@/components/ParentView'
import InnerLink from '@/layout/components/InnerLink'
import { v4 as uuidv4 } from 'uuid'
const permission = {
    namespaced: true,
    state: {
        // 路由表：初始拥有静态路由权限
        routes: [],
        menuList: getItem('menuList') || [],
        subsystem: getItem('subsystem') || ''
    },
    mutations: {
        /**
         * 增加路由
         */
        setRoutes(state, newRoutes) {
            // 永远在静态路由的基础上增加新路由
            state.routes = [...publicRoutes, ...newRoutes]
        },
        setMenu(state, data) {
            setItem('menuList', data)
            state.menuList = data
        },
        setSubsystem(state, data) {
            state.subsystem = data
            setItem('subsystem', data)
        }
    },
    actions: {
        saveSubsystem(context, data) {
            context.commit('setSubsystem', data)
        },
        saveMenu(context, data) {
            context.commit('setMenu', data)
        },
        /**
         * 根据权限生成路由
         */
        filterRoutes(context, allModules) {
            resetRouter()
            if (!context.state.subsystem) {
                // 默认第一个子系统 base
                const currentSys = Object.keys(allModules)[1]
                context.commit('setSubsystem', currentSys)
            }
            const currentMenuList = filterAsyncRouter(deepCopy(allModules[context.state.subsystem]))
            context.commit('setMenu', currentMenuList)
            let routeClone = []
            for (const key in allModules) {
                routeClone = routeClone.concat(deepCopy(allModules[key]))
            }
            const routes = filterAsyncRouter(routeClone)
            context.commit('setRoutes', routes)
            return routes
        }
    }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
    return asyncRouterMap?.filter((route) => {
        if (type && route.children) {
            route.children = filterChildren(route.children)
        }
        if (route.component) {
            // Layout ParentView 组件特殊处理
            if (route.component === 'Layout') {
                route.component = Layout
            } else if (route.component === 'ParentView') {
                route.component = ParentView
            } else if (route.component === 'InnerLink') {
                route.component = InnerLink
            } else {
                route.component = loadView(route.component)
            }
            route.name = route.path + uuidv4()
        }
        if (route.children != null && route.children && route.children.length) {
            route.children = filterAsyncRouter(route.children, route, type)
        } else {
            delete route.children
            delete route.redirect
        }
        return true
    })
}

function filterChildren(childrenMap, lastRouter = false) {
    var children = []
    childrenMap.forEach((el, index) => {
        if (el.children && el.children.length) {
            if (el.component === 'ParentView' && !lastRouter) {
                el.children.forEach((c) => {
                    c.path = el.path + '/' + c.path
                    if (c.children && c.children.length) {
                        children = children.concat(filterChildren(c.children, c))
                        return
                    }
                    children.push(c)
                })
                return
            }
        }
        if (lastRouter) {
            el.path = lastRouter.path + '/' + el.path
        }
        children = children.concat(el)
    })
    return children
}

export const loadView = (view) => {
    return () => import('@/views/' + view + '.vue')
}

export default permission
